import _ from 'lodash'
import SITE_GAP_CONIG from './config'
import imagesLoaded from 'imagesloaded'

class SiteGapClass {
    constructor() {
        this.DOM = {
            main: SITE_GAP_CONIG.main,
            header: SITE_GAP_CONIG.header,
            gapSections: SITE_GAP_CONIG.gapSections,
            breadcrumbs: SITE_GAP_CONIG.breadcrumbs
        }

        this.gap = this.DOM.header.clientHeight

        this.init()
    }

    init() {
        this._listeners()
        this._gap()
        console.log( this )
    }

    _listeners() {
        window.addEventListener( 'resize', this._gap.bind( this ) )
    }

    _gap() {
        this.gap = this.DOM.header.clientHeight
        this.DOM.main.style.paddingTop = `${this.gap}px`
        this.DOM.breadcrumbs ? this.DOM.breadcrumbs.style.top = `${this.gap}px` : null
        this.DOM.gapSections.forEach( ( section ) => {
            let height = section.clientHeight
            section.style.height = `${height - this.gap}px`
        })
    }

}

const SITE_GAP = new SiteGapClass()
export default SITE_GAP